import { Map as IMap } from 'immutable';

export const selectModalVisibility = (state) => state.adminPanelReducer.get('createNewCompanyModalVisible', false);
export const selectAdminStatistic = (state) => state.adminPanelReducer.get('adminStatistic', IMap());
